<script setup lang="ts">
import { computed, onBeforeMount, onMounted, ref } from 'vue';
import ls from "../method/localStorage";
import router from '../router';
import global from '../global';
import { GetLanguagePack, language } from '../model/language'
import { Menu } from '../model/Menu';
import Inquery from '../components/Inquery/Inquery.vue'
import cart from '../components/Inquery/cart.vue'
import InqueryDetail from '../components/Inquery/InqueryDetail.vue'

let selectMenu = ref("0-1");
let Name = ls.get("WebloginId");
let OrgId = ls.get("WebOrgId");
let token = ls.get("WebToken");
const proxy = global();
const lang = ref("简体中文");
const langPack = ref();
const langMap = ref(new Map<string, string>())
const menu = ref(new Menu())
const editableTabsValue = ref('1')
const editableTabs = ref([
    {
        title: '查询报价单',
        name: '1',
        content: 'Inquery',
        id: 0
    },
])
const orientation = computed(() => {
    return proxy.clientWidth.value < proxy.clientHeight.value ? 'vertical' : 'horizontal'
})

onBeforeMount(() => {
    lang.value = ls.get("lang");
    if (lang.value == "") {
        lang.value = "简体中文"
    }
    langPack.value = proxy.LangPack;
    let keys = Reflect.ownKeys(langPack.value);
    keys.forEach(ele => {
        langMap.value.set(ele.toString(), Reflect.get(langPack.value, ele.toString()))
    })
    menu.value.init(langPack.value, () => {
        handleChangeLanguage(lang.value)
    });
    console.log(menu.value)
})
onMounted(() => {
    // 监听屏幕旋转事件，让页面能够根据屏幕方向自动调整
    window.addEventListener('orientationchange', () => {
        // 屏幕旋转时不需要特殊处理，因为在main.ts中已经设置了自动更新尺寸
        console.log('屏幕方向已改变');
    });
})


if (token == null || token == "" || OrgId == null || OrgId == "") {
    alert(langPack.value.tokenErrorMessage);
    router.push("/Login");
}

function LogOut() {
    ls.set("WebToken", "");
    router.push("/Login");
}

const handleChangeLanguage = (lang: string) => {
    proxy.LangPack = GetLanguagePack(lang);
    langPack.value = proxy.LangPack;
    let keys = Reflect.ownKeys(langPack.value);
    keys.forEach(ele => {
        langMap.value.set(ele.toString(), Reflect.get(langPack.value, ele.toString()))
    })

    ls.set("lang", lang);
    menu.value.changeLangPack(langPack.value);
    editableTabsRefresh();
}


const editableTabsRefresh = () => {
    editableTabs.value.forEach(ele => {
        let find = menu.value.find(ele.name);
        ele.title = find.desc
    })
}

const handleMenuChoose = (index: string) => {
    if (proxy.clientHeight && proxy.clientWidth.value > proxy.clientHeight.value) {
        if (editableTabs.value.findIndex(m => m.name == index) == -1) {
            let find = menu.value.find(index);
            editableTabs.value.push({
                title: find.desc,
                name: index,
                content: find.name,
                id: find.id
            })
        }
        editableTabsValue.value = index;
    } else {
        editableTabs.value = [];
        let find = menu.value.find(index);
        editableTabs.value.push({
            title: find.desc,
            name: index,
            content: find.name,
            id: find.id
        })
        editableTabsValue.value = index;
    }

    selectMenu.value = index;
}


const removeTab = (targetName: string) => {
    const tabs = editableTabs.value
    let activeName = editableTabsValue.value
    if (activeName === targetName) {
        tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
                const nextTab = tabs[index + 1] || tabs[index - 1]
                if (nextTab) {
                    activeName = nextTab.name
                }
            }
        })
    }

    let str="123123";
    str.substring(0,str.length-1)
    editableTabsValue.value = activeName
    editableTabs.value = tabs.filter((tab) => tab.name !== targetName)
}

//子组件的跳转请求
const handleAddTab = (e: any) => {
    //e:{title:"标题栏",multi:可重复,content:页面标识}
    if (orientation.value == 'horizontal') {
        if (e.multi) {
            let count = 1;
            editableTabs.value.forEach(tab => {
                if (tab.content == e.content) {
                    let temp = tab.name.substring(editableTabsValue.value.length + 1, tab.name.length);
                    if (count <= Number.parseInt(temp)) {
                        count = Number.parseInt(temp) + 1
                    }
                }
            });

            let index = editableTabsValue.value + '-' + count
            let title = Reflect.get(langPack.value, e.title)
            editableTabs.value.push({
                title: title,
                name: index,
                content: e.content,
                id: Number.parseInt(e.Oid)
            })
            editableTabsValue.value = index;
        } else {
            let index = editableTabsValue.value + "-1";
            if (editableTabs.value.findIndex(m => m.name == index) == -1) {
                let title = Reflect.get(langPack.value, e.title)
                editableTabs.value.push({
                    title: title,
                    name: index,
                    content: e.content,
                    id: Number.parseInt(e.Oid)
                })
            }
            editableTabsValue.value = index;
        }
    } else if (orientation.value == 'vertical') {
        editableTabs.value = [];
        let index = editableTabsValue.value + "-1";
        let title = Reflect.get(langPack.value, e.title)
        editableTabs.value.push({
            title: title,
            name: index,
            content: e.content,
            id: Number.parseInt(e.Oid)
        })
        editableTabsValue.value = index;
    }
}

</script>
<template>
    <el-container class="body" v-if="proxy.clientWidth && proxy.clientHeight && !proxy.isMobileDevice">
        <el-aside class="aside" width="14rem">
            <el-image style="margin: 16px;" :src="('/src/assets/logo.png')" fit="contain" />
            <el-menu mode="vertical" @select="handleMenuChoose" text-color="white">
                <div v-for="item in menu.Menu">
                    <el-menu-item :index="item.index" class="menu" v-if="item.subMenus.length == 0">
                        <span>{{ item.desc }}</span>
                    </el-menu-item>
                    <el-sub-menu class="menu" :index="item.index" v-else="item.subMenus.length>0">
                        <template #title>
                            <span>{{ item.desc }}</span>
                        </template>
                        <el-menu-item :index="ele.index" class="menuitem" v-for="ele in item.subMenus">
                            <span>{{ ele.desc }}</span>
                        </el-menu-item>
                    </el-sub-menu>
                </div>
            </el-menu>
        </el-aside>
        <el-container>
            <el-header class="header">
                <div class="headerRow">
                    <el-text style="margin-right:1rem;">{{ langPack.Hello + ":" + Name }}</el-text>
                    <el-link type="danger" @click="LogOut">{{ langPack.LogOut }}</el-link>
                    <el-select v-model="lang" class="Select" placeholder="Select" size="small"
                        @change="handleChangeLanguage">
                        <el-option v-for="item in language" :key="item" :label="item" :value="item" />
                    </el-select>
                </div>
            </el-header>
            <el-main class="main">
                <el-tabs v-model="editableTabsValue" type="card" class="demo-tabs" closable @tab-remove="removeTab">
                    <el-tab-pane v-for="item in editableTabs" :key="item.name" :label="item.title" :name="item.name">
                        <Inquery v-if="item.content == 'Inquery'" @AddTab="handleAddTab" :langPack="langMap"
                            :lang="lang" :orientation="orientation">
                        </Inquery>
                        <cart v-if="item.content == 'Cart'" :langPack="langMap" :lang="lang" :orientation="orientation">
                        </cart>
                        <InqueryDetail v-if="item.content == 'InqueryDetail'" :langPack="langMap" :id="item.id"
                            :lang="lang" :orientation="orientation">
                        </InqueryDetail>
                    </el-tab-pane>
                </el-tabs>
            </el-main>
            <el-footer class="footer">
                <el-text>
                    CopyRight 奕鸣科技
                </el-text>
                <el-link href="https://www.shipxy.com/ " target="_blank"
                    style="margin-left: 10rem;color: aqua;">船讯网</el-link>
            </el-footer>
        </el-container>
    </el-container>

    <el-container class="body-vertical"
        v-else="proxy.isMobileDevice&&proxy.clientWidth && proxy.clientHeight && proxy.clientWidth.value <= proxy.clientHeight.value">
        <el-header class="header-vertical">
            <div class="headerRow-vertical">
                <el-image :src="('/src/assets/logo.png')" fit="contain" style="height: 40px;" />
                <div style="display: flex; flex-direction: column; align-items: flex-end; margin-right: 10px;">
                    <el-text style="font-size: 12px;color: #fff;">{{ langPack.Hello + ":" + Name }}</el-text>
                    <div style="display: flex; flex-direction: row; align-items: center; gap: 8px;">
                        <el-link type="danger" @click="LogOut" style="font-size: 12px;">{{ langPack.LogOut }}</el-link>
                        <el-select v-model="lang" class="Select-vertical" placeholder="Select" size="small"
                            @change="handleChangeLanguage">
                            <el-option v-for="item in language" :key="item" :label="item" :value="item" />
                        </el-select>
                    </div>
                </div>
            </div>
        </el-header>
        <el-menu class="el-menu-demo" mode="horizontal" @select="handleMenuChoose" background-color="#545c64"
            menu-trigger="click" text-color="#fff" active-text-color="#ffd04b">
            <div v-for="item in menu.Menu">
                <el-menu-item :index="item.index" v-if="item.subMenus.length == 0">
                    <span>{{ item.desc }}</span>
                </el-menu-item>
                <el-sub-menu :index="item.index" v-else="item.subMenus.length>0">
                    <template #title>
                        <span>{{ item.desc }}</span>
                    </template>
                    <el-menu-item :index="ele.index" v-for="ele in item.subMenus">
                        <span>{{ ele.desc }}</span>
                    </el-menu-item>
                </el-sub-menu>
            </div>
        </el-menu>
        <el-main class="main-vertical">
            <!-- 竖屏模式下，显示当前选中的标签内容 -->
            <div v-if="editableTabs.length == 1">
                <Inquery v-if="editableTabs[0].content == 'Inquery'" @AddTab="handleAddTab" :langPack="langMap"
                    :lang="lang" :orientation="orientation">
                </Inquery>
                <cart v-if="editableTabs[0].content == 'Cart'" :langPack="langMap" :lang="lang"
                    :orientation="orientation">
                </cart>
            </div>
        </el-main>
    </el-container>
</template>
<style>
.body {
    width: 100vw;
    height: 100vh;
}

/* 竖屏模式样式 */
.body-vertical {
    width: 100vw;
    height: 100vh;
    /* 适配移动设备浏览器工具栏 */
    height:calc(var(--vh, 1vh) * 100);
    background-color: #f5f5f5;
    display: flex;
    flex-direction: column;
}

.header-vertical {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #3a3a3a;
    border-bottom: 2px solid var(--el-border-color);
    height: 56px;
    padding: 0 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.headerRow-vertical {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.main-vertical {
    padding: 0;
    /* 使用CSS变量计算高度，适配移动设备工具栏 */
    height: calc(var(--vh, 1vh) * 100 - 56px);
    overflow-y: auto;
    /* 解决iOS滚动卡顿问题 */
    -webkit-overflow-scrolling: touch;
}

.footer-vertical {
    height: 80px;
    border-top: 2px solid var(--el-border-color);
    background-color: #fff;
    padding: 5px 0;
    box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
}

.nav-vertical {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    height: 100%;
}

.nav-item-vertical {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 25%;
    height: 100%;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 12px;
}

.nav-item-vertical:active {
    background-color: #f0f0f0;
}

.nav-icon-vertical {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.Select-vertical {
    width: 60px;
    min-width: 60px;
    font-size: 10px;
}

.empty-state {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

/* 横屏模式样式 */
.Avatar {
    margin: 0.2rem;
}

.title {
    color: #fff;
    margin-left: 2rem;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
}

.header {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #fff;
    border-bottom: 2px solid var(--el-border-color);
    height: 2rem;
    min-height: 68px;
    padding: 0;
}

.main {
    padding: 0rem;
    height: 100%;
}

.footer {
    height: 2rem;
    min-height: 30px;
    border-top: 2px solid var(--el-border-color);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.headerRow {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: end;
    align-items: center;
}

.aside {
    background: linear-gradient(180deg, #0883C9 0%, #8CC8EA 100%);
    border-right: 1px solid var(--el-border-color);
}

.menu {
    background: #0280CC;
}

.menuitem {
    background: #0280CC;
}

.menuitem2 {
    background-color: #fff;
}

.Select {
    margin-left: 1rem;
    width: 7rem;
    min-width: 70px;
}
</style>